(function () {
    /**
    *
    * @param container
    * @constructor
    */
   var OnapplyCareerPage = function(container) {
       var container = container;
       var careerSiteFeedUrl = container.getAttribute('data-url');
       var filters = {};
       if (container.hasAttribute('data-prefilters')) {
           filters = JSON.parse(container.getAttribute('data-prefilters'));
       }
       var displayOptions = {};
       if (container.hasAttribute('data-display-options')) {
           displayOptions = JSON.parse(container.getAttribute('data-display-options'));
       }
       var displayStyle = "flex";
       if (container.hasAttribute('data-display-style')) {
           displayStyle = container.getAttribute('data-display-style');
       }
       var listings = [];
       var listingsByDepartment = {};
       var listingElements = [];
       var departmentHeaders = [];
       var visibleDepartments = [];
       var availableDepartments = [];
       var availableLocations = {};
       var language = 'en-US';
       var languageLocaleMatchings = {
           'en' : 'en-US',
           'de' : 'de-DE'
       };
       var translations = {
           'en-US' : {
               'All locations' : 'All locations',
               'All departments' : 'All departments',
               'Learn more' : 'Learn More',
               'Could not load career site' : 'Could not load career site'
           },
           'de-DE' : {
               'All locations' : 'Alle Standorte',
               'All departments' : 'Alle Abteilungen',
               'Learn more' : 'Mehr erfahren',
               'Could not load career site' : 'Die Karriereseite konnte nicht geladen werden'
           }
       };

       var elementClasses = {
           'loader' : 'onapply-loader',
           'list' : 'onapply-job-ad-list',
           'departmentHeader' : 'onapply-department-header',
           'jobAd' : 'onapply-job-ad',
           'jobAdInfo' : 'onapply-job-ad__info',
           'jobAdTitle' : 'onapply-job-ad__title',
           'jobAdLocation' : 'onapply-job-ad__location',
           'jobAdViewButton' : 'onapply-job-ad__view-button'
       };

       function load() {
           var xmlhttp = new XMLHttpRequest();
           var loader = document.createElement("div");
           loader.classList.add(elementClasses['loader']);
           container.appendChild(loader);
           initLanguage();
           xmlhttp.onreadystatechange = function() {
               if (xmlhttp.readyState == XMLHttpRequest.DONE) {
                   if (xmlhttp.status == 200) {
                       responseJson = JSON.parse(xmlhttp.responseText);
                       listings = responseJson.listings;
                       if (!listings) {
                           listings = [];
                       }
                       prefilter();
                       render();
                       container.removeChild(loader);
                   } else {
                       container.innerHTML = translations[language]["Could not load career site"];
                   }
               }
           };
           xmlhttp.open("GET", careerSiteFeedUrl, true);
           xmlhttp.send();
       }

       function prefilter() {
           if (typeof filters.department !== 'undefined') {
               filterByDepartment(filters.department, true);
           }

           if (typeof filters.locality !== 'undefined') {
               filterByLocationComponent('locality', filters.locality, true);
           }

           if (typeof filters.country !== 'undefined') {
               filterByLocationComponent('country', filters.country, true);
           }

           if (typeof filters.employmentType !== 'undefined') {
               filterByEmploymentType(filters.employmentType);
           }
           filters = {};
       }

       function initLanguage() {
           if (container.hasAttribute('data-language')) {
               language = languageLocaleMatchings[container.getAttribute('data-language')];
           }
       }

       function render() {
           if (listings.length == 0) {
               if (displayOptions.emptyMessage) {
                   container.innerHTML = displayOptions.emptyMessage;
               }
               return;
           }
           if (displayOptions.departmentFilter) {
               var departmentDropdown = renderDepartmentDropdown();
               container.appendChild(departmentDropdown);
           }
           if (displayOptions.locationFilter) {
               var locationDropdown = renderLocationDropdown();
               container.appendChild(locationDropdown);
           }
           var list = renderList();
           container.appendChild(list);
           if (displayOptions.pagination) {
               var paginationButtons = pagination.render();
               container.appendChild(paginationButtons);
               pagination.init();
           }
       }

       function applyFilters() {
           visibleDepartments = availableDepartments;
           for (var i = 0; i < listingElements.length; i++) {
               var listingElement = listingElements[i];
               if (typeof listingElement !== "undefined") {
                   listingElement.style.display = displayStyle;
               }
           }
           if (typeof filters.department !== 'undefined') {
               filterByDepartment(filters.department, false);
           }
           filterDepartmentHeaders(filters.department);

           if (typeof filters.locality !== 'undefined') {
               filterByLocationComponent('locality', filters.locality, false);
           }

           if (typeof filters.country !== 'undefined') {
               filterByLocationComponent('country', filters.country, false);
           }
           if (displayOptions.pagination) {
               pagination.init();
           }
           filterDepartmentHeadersByDepartments(visibleDepartments);
       }

       function renderLocationDropdown() {
           //collect available locations
           for (var j = 0; j < listings.length; j++) {
               var listing = listings[j];
               for (var i = 0; i < listing.locations.length; i++) {
                   var location = listing.locations[i];
                   var country = getTranslatedCountry(location);
                   var locality = location.locality;
                   if (!availableLocations.hasOwnProperty(country)) {
                       availableLocations[country] = [];
                   }
                   if (typeof locality !== "undefined" && availableLocations[country].indexOf(locality) < 0) {
                       availableLocations[country].push(locality);
                   }
               }
           }
           var countries = Object.getOwnPropertyNames(availableLocations);
           for (var i = 0; i < countries.length; i++) {
               var country = countries[i];
               availableLocations[country].sort(function(a, b){
                   if(a < b) return -1;
                   if(a > b) return 1;
                   return 0;
               });
           }
           //Create dropwdown with locations
           var select = document.createElement("select");
           var option = document.createElement("option");
           option.value = "all";
           option.text = translations[language]['All locations'];
           select.appendChild(option);
           for (var i = 0; i < countries.length; i++) {
               var country = countries[i];
               var option = document.createElement("option");
               option.value = country;
               option.text = "---" + country + "---";
               option.setAttribute("data-type", "country");
               select.appendChild(option);
               var localities = availableLocations[country];
               for (var j = 0; j < localities.length; j++) {
                   var locality = localities[j];
                   var option = document.createElement("option");
                   option.value = locality;
                   option.text = locality;
                   option.setAttribute("data-type", "locality");
                   select.appendChild(option);
               }
           }
           //Add listener to dropdown
           select.addEventListener("change", function() {
               var selectedOption = select.options[select.selectedIndex];
               filters.locality = undefined;
               filters.country = undefined;
               if (selectedOption.value != "all") {
                   var type = selectedOption.getAttribute("data-type");
                   filters[type] = selectedOption.value;
               }
               applyFilters();
           });
           return select;
       }

       function renderDepartmentDropdown() {
           //Collect available departments
           for (var i = 0; i < listings.length; i++) {
               var listing = listings[i];
               if (availableDepartments.indexOf(getTranslatedDepartment(listing)) < 0) {
                   availableDepartments.push(getTranslatedDepartment(listing));
               }
           }
           //Sort alphabetically
           availableDepartments.sort(function(a, b){
               if(a < b) return -1;
               if(a > b) return 1;
               return 0;
           });
           //Create dropdown with departments
           var select = document.createElement("select");
           var option = document.createElement("option");
           option.value = "all";
           option.text = translations[language]['All departments'];
           select.appendChild(option);
           for (var i = 0; i < availableDepartments.length; i++) {
               var department = availableDepartments[i];
               var option = document.createElement("option");
               option.value = department;
               option.text = department;
               select.appendChild(option);
           }
           //Add listener to dropdown
           select.addEventListener("change", function() {
               filters.department = select.value;
               if (select.value == "all") {
                   filters.department = undefined;
               }
               applyFilters();
           });
           return select;

       }

       function renderList() {
           var list = document.createElement("div");
           list.classList.add(elementClasses['list']);
           if (typeof displayOptions.byDepartment !== "undefined" && displayOptions.byDepartment) {
               listingsByDepartment = {};
               var departments = [];
               for (var i = 0; i < listings.length; i++) {
                   var listing = listings[i];
                   if (!listingsByDepartment.hasOwnProperty(getTranslatedDepartment(listing))) {
                       listingsByDepartment[getTranslatedDepartment(listing)] = [];
                       departments.push(getTranslatedDepartment(listing));
                   }
                   listingsByDepartment[getTranslatedDepartment(listing)].push(listing);
               }
               for (var i = 0; i < departments.length; i++) {
                   var department = departments[i];
                   var departmentHeader = document.createElement('div');
                   departmentHeader.classList.add(elementClasses['departmentHeader']);
                   departmentHeader.setAttribute("data-department", department);
                   departmentHeader.innerHTML = department;
                   departmentHeaders.push(departmentHeader);
                   list.appendChild(departmentHeader);
                   for (var j = 0; j < listingsByDepartment[department].length; j++) {
                       list.appendChild(renderListElement(listingsByDepartment[department][j]));
                   }
               }
           } else {
               for (var i = 0; i < listings.length; i++) {
                   list.appendChild(renderListElement(listings[i]));
               }
           }
           return list;
       }

       function renderListElement(listing) {
           var moreButton = true;
           if (typeof displayOptions.moreButton !== "undefined") {
               moreButton = displayOptions.moreButton;
           }
           var listElement = document.createElement("div");
           listElement.classList.add(elementClasses['jobAd']);
           var info = document.createElement("div");
           info.classList.add(elementClasses['jobAdInfo']);
           var button = document.createElement("a");
           var jobAdLink = listing.linkJobAd + "?source=careerSiteWidget";
           button.setAttribute("href", jobAdLink);
           button.setAttribute("target", "_blank");
           var title = document.createElement("div");
           title.classList.add(elementClasses['jobAdTitle']);
           if (moreButton) {
               button.innerHTML = translations[language]['Learn more'];
               button.classList.add(elementClasses['jobAdViewButton']);
               title.innerHTML = listing.name;
           } else {
               button.innerHTML = listing.name;
               title.appendChild(button);
           }

           var locationElement = document.createElement("div");
           locationElement.classList.add(elementClasses['jobAdLocation']);
           var locationString = '';
           var locations = listing.locations;
           for (var i = 0; i < locations.length; i++) {
               var location = locations[i];
               if (locationString != '') {
                   locationString = locationString + ' | ';
               }
               locationString = locationString + getTranslatedLocationName(location);
           }
           locationElement.innerHTML = locationString;
           info.appendChild(title);
           info.appendChild(locationElement);
           listElement.appendChild(info);
           if (moreButton) {
               listElement.appendChild(button);
           }
           listElement.setAttribute("data-id", listing.counter);
           listingElements[listing.counter] = listElement;
           return listElement;
       }

       function filterByLocationComponent(locationComponent, filterValue, prefilter) {
           visibleDepartments = [];
           for (i = 0; i < listings.length; i++) {
               var listing = listings[i];
               var hide = true;
               for (var j = 0; j < listing.locations.length; j++) {
                   var location = listing.locations[j];
                   var value;
                   if (locationComponent == 'locality') {
                       value = location[locationComponent];
                   } else {
                       value = getTranslatedCountry(location);
                   }
                   if (value == filterValue || typeof value == filterValue) {
                       hide = false;
                   }
               }
               if (hide) {
                   if (prefilter) {
                       listings.splice(i, 1);
                       i--;
                   } else {
                       var listingElement = listingElements[listing.counter];
                       listingElement.style.display = "none";
                   }
               }
               if (!hide) {
                   visibleDepartments.push(getTranslatedDepartment(listing));
               }
           }
       }

       function filterByDepartment(department, prefilter) {
           for (i = 0; i < listings.length; i++) {
               var listing = listings[i];
               if (getTranslatedDepartment(listing) != department) {
                   if (prefilter) {
                       listings.splice(i, 1);
                       i--;
                   } else {
                       var listingElement = listingElements[listing.counter];
                       listingElement.style.display = "none";
                   }
               }
           }
       }

       function filterByEmploymentType(employmentTypeName) {
           for (var i = 0; i < listings.length; i++) {
               var listing = listings[i];
               var employmentTypes = listing.employmentTypes;
               var hasEmploymentType = false;
               for (var j = 0; j < employmentTypes.length; j++) {
                   employmentType = employmentTypes[j];
                   if (employmentTypeName == employmentType.name) {
                       hasEmploymentType = true;
                       break;
                   }
               }
               if (!hasEmploymentType) {
                   listings.splice(i, 1);
                   i--;
               }
           }
       }

       function filterDepartmentHeaders(department) {
           var departmentHeaders = document.getElementsByClassName(elementClasses['departmentHeader']);
           for (i = 0; i < departmentHeaders.length; i++) {
               var departmentHeader = departmentHeaders[i];
               departmentHeader.style.display = "block";
               if (departmentHeader.getAttribute("data-department") != department && typeof department != "undefined") {
                   departmentHeader.style.display = "none";
               }
           }
       }

       function filterDepartmentHeadersByDepartments(departments) {
           for (i = 0; i < departmentHeaders.length; i++) {
               var departmentHeader = departmentHeaders[i];
               var department = departmentHeader.getAttribute('data-department');
               if (departments.indexOf(department) < 0) {
                   departmentHeader.style.display = "none";
               } else {
                   departmentHeader.style.display = displayStyle;
               }
           }
       }

       function getTranslatedDepartment(listing) {
           return listing['department_' + language];
       }

       function getTranslatedCountry(location) {
           return location['country_' + language];
       }

       function getTranslatedLocationName(location) {
           return location['name_' + language];
       }

       var pagination = {
           pageSize : displayOptions.pagination,
           currentPage : 0,
           pages : [],
           previousButton : undefined,
           nextButton : undefined,
           currentPageIndicator : undefined,
           maxPageIndicator : undefined,
           elementClasses : {
               'paginationButtons' : 'pagination-buttons',
               'paginationButton' : 'pagination-buttons__button',
               'pageIndicator' : 'pagination-buttons__page-indicator',
               'paginationButtonDisabled' : 'pagination-buttons__button--disabled'
           },
           init: function() {
               this.currentPage = 0;
               this.pages = [];
               var currentPage = 0;
               var currentCounter = 0;
               var availableListings = listings;
               if (typeof displayOptions.byDepartment !== "undefined" && displayOptions.byDepartment) {
                   availableListings = [];
                   for (var i = 0; i < availableDepartments.length; i++) {
                       var department = availableDepartments[i];
                       availableListings = availableListings.concat(listingsByDepartment[department]);
                   }
               }
               for (var i = 0; i < availableListings.length; i++) {
                   var listing = availableListings[i];
                   var listingElement = listingElements[listing.counter];
                   if (listingElement.style.display == displayStyle || listingElement.style.display == '') {
                       listingElement.style.display = "none";
                       if (this.pages[currentPage] == undefined) {
                           currentCounter = 0;
                           this.pages[currentPage] = [];
                       }
                       this.pages[currentPage].push(listing);
                       currentCounter++;
                       if (currentCounter >= this.pageSize) {
                           currentPage++;
                       }
                   }
               }
               this.maxPageIndicator.innerHTML = this.pages.length;
               this.update(0, false);
           },

           render: function() {
               var pagination = this;
               this.previousButton = document.createElement("a");
               this.previousButton.innerHTML = '<<';
               this.previousButton.classList.add(this.elementClasses['paginationButton']);
               this.previousButton.addEventListener("click", function() {
                   pagination.previous();
               });
               this.nextButton = document.createElement("a");
               this.nextButton.innerHTML = '>>';
               this.nextButton.classList.add(this.elementClasses['paginationButton']);
               this.nextButton.addEventListener("click", function() {
                   pagination.next();
               });
               this.currentPageIndicator = document.createElement("span");
               this.maxPageIndicator = document.createElement("span");
               this.pageIndicator = document.createElement("div");
               this.pageIndicator.classList.add(this.elementClasses['pageIndicator']);
               this.pageIndicator.appendChild(this.currentPageIndicator);
               this.pageIndicator.appendChild(this.maxPageIndicator);
               var paginationButtons = document.createElement("div");
               paginationButtons.classList.add(this.elementClasses['paginationButtons']);
               paginationButtons.appendChild(this.previousButton);
               paginationButtons.appendChild(this.pageIndicator);
               paginationButtons.appendChild(this.nextButton);
               return paginationButtons;
           },
           next: function() {
               if (this.pages.length <= this.currentPage + 1) {
                   return;
               }
               if (this.currentPage >= 0) {
                   this.update(this.currentPage, true);
               }
               this.currentPage++;
               this.update(this.currentPage, false);
           },

           update: function(page, hide) {
               if (!hide) {
                   visibleDepartments = [];
               }
               listingsToShow = this.pages[page];
               if (typeof listingsToShow == 'undefined') {
                   this.updatePageIndicator(-1);
                   return;
               }
               for (var i = 0; i < listingsToShow.length; i++) {
                   var listing = listingsToShow[i];
                   if (!hide && visibleDepartments.indexOf(listing.department) < 0) {
                       visibleDepartments.push(listing.department)
                   }
                   var listingElement = listingElements[listing.counter];
                   if (hide) {
                       listingElement.style.display = "none";
                   } else {
                       listingElement.style.display = displayStyle;
                   }
               }
               if (!hide) {
                   filterDepartmentHeadersByDepartments(visibleDepartments);
               }
               this.updatePageIndicator(page);
           },

           updatePageIndicator: function (page) {
               this.currentPageIndicator.innerHTML = page + 1;
               if (page >= this.pages.length - 1) {
                   this.nextButton.classList.add(this.elementClasses["paginationButtonDisabled"]);
               } else {
                   this.nextButton.classList.remove(this.elementClasses["paginationButtonDisabled"]);
               }

               if (page <= 0) {
                   this.previousButton.classList.add(this.elementClasses["paginationButtonDisabled"]);
               } else {
                   this.previousButton.classList.remove(this.elementClasses["paginationButtonDisabled"]);
               }
           },

           previous: function() {
               if (this.currentPage <= 0) {
                   return;
               }
               this.update(this.currentPage, true);
               this.currentPage--;
               this.update(this.currentPage, false);
           }
       };

       return {
           load: load
       };
   };
   var onapplyCareerPageLoadCounter = 0;
   // window.onload = function() {
       if (onapplyCareerPageLoadCounter > 0) {
           return;
       }
       var onapplyCareerPageContainers = document.getElementsByClassName('onapply-career-page-container');
       for (var i = 0; i < onapplyCareerPageContainers.length; i++) {
           var container = onapplyCareerPageContainers[i];
           var onapplyCareerPage = new OnapplyCareerPage(container);
           onapplyCareerPage.load();
       }
       onapplyCareerPageLoadCounter++;
   // };
   
}());